import {
  AutocompleteInput,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const customerListFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.code"
      resettable
      variant="outlined"
    />,
    <SelectInput
      alwaysOn
      source="type"
      label="mine.label.type"
      resettable
      variant="outlined"
      choices={[
        { id: "BIGT", name: "BIGT - BIG TRADER" },
        { id: "MIDL", name: "MIDL - MIDDLE TRADER" },
        { id: "RETL", name: "SMALL TRADER" },
      ]}
    />,
    <TextInput
      alwaysOn
      source="salesman"
      resettable
      variant="outlined"
    />,
    <SelectInput
      alwaysOn
      source="active"
      label="Status"
      resettable
      variant="outlined"
      choices={[
        { id: "1", name: "Aktif" },
        { id: "0", name: "Tidak Aktif" },
      ]}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default customerListFilterList;
